import { formatNumber } from "@memorang/helpers/common";
import type { MixedItemTag } from "@memorang/types";
import type { OptionListOption } from "@memorang/ui/components/QuickStudyModal/OptionList";
import { resolveTagIcon } from "@memorang/ui/constants";
import type { LevelIconName } from "@memorang/ui/icon";
import type { TFunction } from "i18next";

type FlatSectionOptionsResult = {
	options: OptionListOption[];
};

export const buildFlatSectionOptions = ({
	tags,
	selectedTagCheckboxMap,
	hideTotalItemCounts,
	rowIconMap,
	rowDefaultIcon,
	t,
}: {
	tags: MixedItemTag[];
	selectedTagCheckboxMap?: Record<string, boolean>;
	hideTotalItemCounts?: boolean;
	rowIconMap: Record<string, LevelIconName>;
	rowDefaultIcon: LevelIconName;
	t: TFunction;
}): FlatSectionOptionsResult => {
	const freeTags = tags.filter((tag) => !tag.locked);

	const options: OptionListOption[] = freeTags.map((tag) => {
		const count = tag.numItems ?? 0;
		return {
			id: String(tag.id),
			label: tag.title,
			icon: resolveTagIcon(tag, rowIconMap) ?? rowDefaultIcon,
			countLabel: hideTotalItemCounts
				? undefined
				: `${formatNumber(count)} ${t("common.item", { count })}`,
			checked: count > 0 && Boolean(selectedTagCheckboxMap?.[tag.id]),
			unavailable: count === 0,
		};
	});

	return { options };
};
